// Change Email Address widget (profile > _email_change_field). Delegated, so it survives Turbolinks visits.
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

function csrfToken() {
  const meta = document.querySelector("meta[name='csrf-token']")
  return meta ? meta.content : ''
}

function post(widget, url, method, body) {
  const data = Object.assign({}, body)
  if (widget.dataset.userId) data.user_id = widget.dataset.userId
  return fetch(url, {
    method: method,
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify(data)
  }).then(function (resp) {
    return resp.json().catch(function () { return {} }).then(function (json) { return { ok: resp.ok, json: json } })
  })
}

function modalFor(widget) {
  return window.bootstrap.Modal.getOrCreateInstance(widget.querySelector('.js-email-modal'))
}

function setNotice(widget, message, isError) {
  const notice = widget.querySelector('.js-email-modal-notice')
  notice.textContent = message
  notice.classList.toggle('text-danger', !!isError)
  notice.classList.toggle('text-success', !isError)
}

function setError(widget, message) {
  widget.querySelector('.js-email-error').textContent = message || ''
}

function openNewRow(widget) {
  widget.querySelector('.js-email-new-row').classList.remove('d-none')
  widget.querySelector('.js-email-change-link-row').classList.add('d-none')
  const input = widget.querySelector('.js-email-new-input')
  input.focus()
}

function closeNewRow(widget) {
  widget.querySelector('.js-email-new-row').classList.add('d-none')
  widget.querySelector('.js-email-change-link-row').classList.remove('d-none')
  widget.querySelector('.js-email-new-input').value = ''
  setError(widget, '')
}

function showPending(widget, email) {
  widget.querySelector('.js-email-pending-address').textContent = email
  widget.querySelector('.js-email-pending').classList.remove('d-none')
  widget.querySelector('.js-email-modal-address').textContent = email
}

function submitNewEmail(widget) {
  const input = widget.querySelector('.js-email-new-input')
  const value = input.value.trim()
  if (!EMAIL_FORMAT.test(value)) return setError(widget, 'Enter a valid email address.')

  setError(widget, '')
  post(widget, widget.dataset.createUrl, 'POST', { new_email: value }).then(function (res) {
    if (!res.ok) return setError(widget, res.json.error || 'Could not send the verification email. Try again.')

    showPending(widget, res.json.email)
    closeNewRow(widget)
    setNotice(widget, '', false)
    modalFor(widget).show()
  })
}

document.addEventListener('click', function (e) {
  const widget = e.target.closest('.js-email-change')
  if (!widget) return
  const hit = function (selector) { return e.target.closest(selector) }

  if (hit('.js-email-change-open')) return openNewRow(widget)
  if (hit('.js-email-close')) return closeNewRow(widget)
  if (hit('.js-email-confirm')) return submitNewEmail(widget)

  if (hit('.js-email-modal-change')) {
    modalFor(widget).hide()
    return openNewRow(widget)
  }

  if (hit('.js-email-resend') || hit('.js-email-modal-resend')) {
    const inModal = !!hit('.js-email-modal-resend')
    post(widget, widget.dataset.resendUrl, 'POST', {}).then(function (res) {
      if (inModal) setNotice(widget, res.ok ? 'Verification email sent again.' : 'Could not resend the email. Try again.', !res.ok)
      else if (res.ok) {
        widget.querySelector('.js-email-modal-address').textContent = res.json.email
        setNotice(widget, 'Verification email sent again.', false)
        modalFor(widget).show()
      }
    })
    return
  }

  if (hit('.js-email-cancel')) {
    post(widget, widget.dataset.cancelUrl, 'DELETE', {}).then(function (res) {
      if (res.ok) widget.querySelector('.js-email-pending').classList.add('d-none')
    })
  }
})

// Enter in the new-email box must confirm the change, not submit the surrounding profile form.
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' || !e.target.classList || !e.target.classList.contains('js-email-new-input')) return
  e.preventDefault()
  submitNewEmail(e.target.closest('.js-email-change'))
})
